<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row align="center" dense>
                    <v-item-group v-model="window" class="shrink mr-6" mandatory tag="v-flex">
                        <v-item v-slot:default="{ active, toggle }">
                            <div>
                                <v-btn :input-value="active" color="primary" icon @click="toggle">
                                    <v-icon>account_circle</v-icon>
                                </v-btn>
                            </div>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }">
                            <div>
                                <v-btn :input-value="active" color="primary" icon @click="toggle">
                                    <v-icon>security</v-icon>
                                </v-btn>
                            </div>
                        </v-item>
                    </v-item-group>

                    <v-col>
                        <v-window v-model="window" class="elevation-0" vertical>
                            <v-window-item>
                                <WindowItemInformacionComponent/>
                            </v-window-item>
                            <v-window-item>
                                <WindowItemCambioContraseniaComponent :active="window == 1 ? true : false"/>
                            </v-window-item>
                        </v-window>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>


</template>

<script>
    export default {
        components:{
            WindowItemInformacionComponent: () => import('@/components/seguridad/WindowItemInformacionComponent.vue'),
            WindowItemCambioContraseniaComponent: () => import('@/components/seguridad/WindowItemCambioContraseniaComponent.vue')
        },
        data: () => ({
            window: 0,
        }),
    }
</script>